import IconButton from '@mui/material/IconButton';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { useDispatch } from 'react-redux';
import { setChannelSettingsDialogData } from 'app/store/userSettingsSlice';

function ChannelSettingsButton({ channelId, rootChannelId, channelType, channelName }) {
  const dispatch = useDispatch();

  // Only show for group/team/org channels, not DMs
  if (!channelId) {
    return null;
  }

  const handleClick = () => {
    dispatch(setChannelSettingsDialogData({ channelId, rootChannelId, channelType, channelName }));
  };

  return (
    <IconButton
      className="w-40 h-40"
      onClick={handleClick}
      size="small"
    >
      <FuseSvgIcon size={20}>heroicons-outline:cog</FuseSvgIcon>
    </IconButton>
  );
}

export default ChannelSettingsButton;